 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"customer-riskr":"customer-riskr","example-NotFound":"example-NotFound","example-aboult":"example-aboult","example-ajax~example-knowledgeBase~example-sop":"example-ajax~example-knowledgeBase~example-sop","example-ajax":"example-ajax","example-sop~example-workOrderManagement":"example-sop~example-workOrderManagement","example-sop":"example-sop","example-businessKnowledge":"example-businessKnowledge","example-configuration-center":"example-configuration-center","example-configuration-center-popStore":"example-configuration-center-popStore","example-eventlist":"example-eventlist","example-example-configuration-center~example-intellectQuality~example-monitor~example-robot~example-~26fcffcf":"example-example-configuration-center~example-intellectQuality~example-monitor~example-robot~example-~26fcffcf","example-example-configuration-center~example-monitor~example-taskManagement-myTask~example-workOrder~3a6f133d":"example-example-configuration-center~example-monitor~example-taskManagement-myTask~example-workOrder~3a6f133d","example-example-configuration-center~example-monitor~example-taskManagement-myTask~searchIndex":"example-example-configuration-center~example-monitor~example-taskManagement-myTask~searchIndex","example-example-configuration-center~example-knowledgeBase~example-taskManagement-myTask~searchIndex":"example-example-configuration-center~example-knowledgeBase~example-taskManagement-myTask~searchIndex","example-example-configuration-center":"example-example-configuration-center","example-taskManagement-myTask":"example-taskManagement-myTask","searchIndex":"searchIndex","example-intellectQuality~example-monitor":"example-intellectQuality~example-monitor","example-monitor":"example-monitor","example-intellectQuality":"example-intellectQuality","example-robot":"example-robot","example-session":"example-session","example-knowledgeBase":"example-knowledgeBase","example-workOrderManagement":"example-workOrderManagement","example-juridistion":"example-juridistion","example-newbusiness":"example-newbusiness","example-robotConfig":"example-robotConfig","example-sendSms":"example-sendSms","example-workUnlock":"example-workUnlock","messageQueryt":"messageQueryt","xinyunpage-log":"xinyunpage-log","xinyunweb-workOrderManagement":"xinyunweb-workOrderManagement","yunjiadmin-system-system":"yunjiadmin-system-system"}[chunkId]||chunkId) + "." + {"customer-riskr":"324b5cb0","example-NotFound":"50dda86d","example-aboult":"7a32ca72","example-ajax~example-knowledgeBase~example-sop":"6c567860","example-ajax":"7b069155","example-sop~example-workOrderManagement":"52a774a2","example-sop":"772e317b","example-businessKnowledge":"6b7b6aa4","example-configuration-center":"2f430a76","example-configuration-center-popStore":"70aac80b","example-eventlist":"87dfc2e1","example-example-configuration-center~example-intellectQuality~example-monitor~example-robot~example-~26fcffcf":"db0016d0","example-example-configuration-center~example-monitor~example-taskManagement-myTask~example-workOrder~3a6f133d":"15ce0409","example-example-configuration-center~example-monitor~example-taskManagement-myTask~searchIndex":"c61a55ae","example-example-configuration-center~example-knowledgeBase~example-taskManagement-myTask~searchIndex":"6162a3d7","example-example-configuration-center":"f7538f2b","example-taskManagement-myTask":"1daa3890","searchIndex":"e2df6e16","example-intellectQuality~example-monitor":"d5f60636","example-monitor":"0c32e606","example-intellectQuality":"f57b3323","example-robot":"f2daf8c8","example-session":"d39c92a6","example-knowledgeBase":"11654844","example-workOrderManagement":"91a34e01","example-juridistion":"da8a3006","example-newbusiness":"098d0c21","example-robotConfig":"54d786bc","example-sendSms":"d0fa8f5a","example-workUnlock":"f80f8df0","messageQueryt":"2d8e66bb","xinyunpage-log":"8e50e18e","xinyunweb-workOrderManagement":"25a45b66","yunjiadmin-system-system":"435e91ce"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"customer-riskr":1,"example-aboult":1,"example-ajax":1,"example-sop":1,"example-businessKnowledge":1,"example-configuration-center":1,"example-configuration-center-popStore":1,"example-eventlist":1,"example-example-configuration-center~example-intellectQuality~example-monitor~example-robot~example-~26fcffcf":1,"example-example-configuration-center~example-monitor~example-taskManagement-myTask~example-workOrder~3a6f133d":1,"example-example-configuration-center~example-monitor~example-taskManagement-myTask~searchIndex":1,"example-example-configuration-center~example-knowledgeBase~example-taskManagement-myTask~searchIndex":1,"example-example-configuration-center":1,"example-taskManagement-myTask":1,"searchIndex":1,"example-monitor":1,"example-intellectQuality":1,"example-robot":1,"example-session":1,"example-knowledgeBase":1,"example-workOrderManagement":1,"example-juridistion":1,"example-newbusiness":1,"example-robotConfig":1,"example-sendSms":1,"messageQueryt":1,"xinyunpage-log":1,"xinyunweb-workOrderManagement":1,"yunjiadmin-system-system":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"customer-riskr":"customer-riskr","example-NotFound":"example-NotFound","example-aboult":"example-aboult","example-ajax~example-knowledgeBase~example-sop":"example-ajax~example-knowledgeBase~example-sop","example-ajax":"example-ajax","example-sop~example-workOrderManagement":"example-sop~example-workOrderManagement","example-sop":"example-sop","example-businessKnowledge":"example-businessKnowledge","example-configuration-center":"example-configuration-center","example-configuration-center-popStore":"example-configuration-center-popStore","example-eventlist":"example-eventlist","example-example-configuration-center~example-intellectQuality~example-monitor~example-robot~example-~26fcffcf":"example-example-configuration-center~example-intellectQuality~example-monitor~example-robot~example-~26fcffcf","example-example-configuration-center~example-monitor~example-taskManagement-myTask~example-workOrder~3a6f133d":"example-example-configuration-center~example-monitor~example-taskManagement-myTask~example-workOrder~3a6f133d","example-example-configuration-center~example-monitor~example-taskManagement-myTask~searchIndex":"example-example-configuration-center~example-monitor~example-taskManagement-myTask~searchIndex","example-example-configuration-center~example-knowledgeBase~example-taskManagement-myTask~searchIndex":"example-example-configuration-center~example-knowledgeBase~example-taskManagement-myTask~searchIndex","example-example-configuration-center":"example-example-configuration-center","example-taskManagement-myTask":"example-taskManagement-myTask","searchIndex":"searchIndex","example-intellectQuality~example-monitor":"example-intellectQuality~example-monitor","example-monitor":"example-monitor","example-intellectQuality":"example-intellectQuality","example-robot":"example-robot","example-session":"example-session","example-knowledgeBase":"example-knowledgeBase","example-workOrderManagement":"example-workOrderManagement","example-juridistion":"example-juridistion","example-newbusiness":"example-newbusiness","example-robotConfig":"example-robotConfig","example-sendSms":"example-sendSms","example-workUnlock":"example-workUnlock","messageQueryt":"messageQueryt","xinyunpage-log":"xinyunpage-log","xinyunweb-workOrderManagement":"xinyunweb-workOrderManagement","yunjiadmin-system-system":"yunjiadmin-system-system"}[chunkId]||chunkId) + "." + {"customer-riskr":"605d7b40","example-NotFound":"31d6cfe0","example-aboult":"d996d2a5","example-ajax~example-knowledgeBase~example-sop":"31d6cfe0","example-ajax":"8f457174","example-sop~example-workOrderManagement":"31d6cfe0","example-sop":"b6099dc1","example-businessKnowledge":"1b2dd03c","example-configuration-center":"ddfdcd58","example-configuration-center-popStore":"0f022aa7","example-eventlist":"9e79ceb5","example-example-configuration-center~example-intellectQuality~example-monitor~example-robot~example-~26fcffcf":"fd9bb4f1","example-example-configuration-center~example-monitor~example-taskManagement-myTask~example-workOrder~3a6f133d":"1dbe9599","example-example-configuration-center~example-monitor~example-taskManagement-myTask~searchIndex":"9f4f9c95","example-example-configuration-center~example-knowledgeBase~example-taskManagement-myTask~searchIndex":"7f64204a","example-example-configuration-center":"1d47b6be","example-taskManagement-myTask":"afb88006","searchIndex":"f1134ff2","example-intellectQuality~example-monitor":"31d6cfe0","example-monitor":"7539bdfd","example-intellectQuality":"d6383d52","example-robot":"2517b196","example-session":"1804a586","example-knowledgeBase":"444cfd2b","example-workOrderManagement":"ce551068","example-juridistion":"896b54f3","example-newbusiness":"285a5fdb","example-robotConfig":"ba9e2e72","example-sendSms":"f4592768","example-workUnlock":"31d6cfe0","messageQueryt":"e01bad92","xinyunpage-log":"2bc4f723","xinyunweb-workOrderManagement":"a2abff37","yunjiadmin-system-system":"63927c7a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/xinyunweb/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
